import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PermissionProvider } from './contexts/PermissionContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { BusinessSettingsProvider } from './contexts/BusinessSettingsContext';
import ETPOSDashboard from "./ETPOSDashboard";
import AddUser from "./components/AddUser";
import AddRole from "./components/AddRole";
import AddRoleNew from "./components/AddRoleNew";
import AddAgent from "./components/AddAgent";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import AddProduct from "./AddProduct";
import AddSupplier from "./components/ETPOS/AddSupplier";
import Profile from "./components/Profile";
import POSPage from './components/ETPOS/POSPage';
import AiAssistantDashboard from './pages/AiAssistant/index';
import GenerateTool from './pages/AiAssistant/GenerateTool';
import AiHistory from './pages/AiAssistant/History';
import SubscriptionGuard from './components/SubscriptionGuard';
import AddPurchaseOrder from './components/ETPOS/AddPurchaseOrder';
import AddPurchaseRequisition from './components/ETPOS/AddPurchaseRequisition';
import AddPurchaseReturn from './components/ETPOS/AddPurchaseReturn';
import AddPurchase from './components/ETPOS/AddPurchase';

import { useNetworkStatus } from './hooks/useNetworkStatus';
import { startSyncManager } from './services/syncManager';

function App() {
  const isOnline = useNetworkStatus();

  React.useEffect(() => {
    startSyncManager();
  }, []);

  return (
    <Router>
      <BusinessSettingsProvider>
        <PermissionProvider>
          <SubscriptionProvider>
          <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 100000001 }} />
          {!isOnline && (
            <div style={{
              backgroundColor: '#ef4444',
              color: 'white',
              textAlign: 'center',
              padding: '8px',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              zIndex: 999999999,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              ⚠️ You are currently offline. Changes will be synced when the internet is restored.
            </div>
          )}
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Standalone POS Page */}
          <Route path="/pos" element={<ProtectedRoute><POSPage /></ProtectedRoute>} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><ETPOSDashboard /></ProtectedRoute>}>
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="home" element={null} />
            <Route path="users" element={null} />
            <Route path="users/add" element={<AddUser />} />
            <Route path="roles/add" element={<AddRoleNew />} />
            <Route path="sales-commission-agents/add" element={<AddAgent />} />
            <Route path="products/add" element={<AddProduct />} />
             <Route path="contacts/suppliers/add" element={<AddSupplier />} />
             <Route path="contacts/suppliers/edit/:id" element={<AddSupplier />} />
             <Route path="contacts/customers/add" element={<AddSupplier />} />
             <Route path="contacts/customers/edit/:id" element={<AddSupplier />} />
             <Route path="profile" element={<Profile />} />
            <Route path="ai-assistant" element={<SubscriptionGuard module="ai_assistance"><AiAssistantDashboard /></SubscriptionGuard>} />
            <Route path="ai-assistant/history" element={<SubscriptionGuard module="ai_assistance"><AiHistory /></SubscriptionGuard>} />
            <Route path="ai-assistant/:toolId" element={<SubscriptionGuard module="ai_assistance"><GenerateTool /></SubscriptionGuard>} />
            <Route path="sell" element={null} />
            <Route path="sell/*" element={null} />
            <Route path="add-purchase" element={<AddPurchase onBack={() => window.location.href = '/purchases'} />} />
            <Route path="purchases/order/add" element={<AddPurchaseOrder />} />
            <Route path="purchases/requisition/add" element={<AddPurchaseRequisition />} />
            <Route path="purchases/return/add" element={<AddPurchaseReturn />} />
            <Route path="purchase-return/edit/:id" element={<AddPurchaseReturn />} />
            <Route path="purchase-return/add/:id" element={<AddPurchaseReturn />} />
            <Route path="*" element={null} />
          </Route>

          {/* Redirect any unmatched routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
          </SubscriptionProvider>
        </PermissionProvider>
      </BusinessSettingsProvider>
    </Router>
  );
}

export default App;
